import React from "react";
import { Box, Grid, Typography, CircularProgress } from "@material-ui/core";
import { useQuery, gql } from "@apollo/client";
import { Card } from "react-bootstrap";

import {
  faUsers,
  faClipboardCheck,
  faPoll,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FetchDbStats } from "../apis";
import { shallowEqual, useSelector } from "react-redux";
import { FetchOrganizationDbStats } from "../../../apis";

const GET_STATS = gql`
  query Query {
    getAdminStatistics {
      totalUsersCount
      quizCount
      resumesCount
    }
  }
`;

export function StatsOverview() {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const { data, loading } = useQuery(GET_STATS);
  const [userCount, setUserCount] = React.useState(0);
  const [resumeCount, setResumeCount] = React.useState(0);
  const [assessMentCount, setAssessMentCountCount] = React.useState(0);

  const statsList = [
    {
      title: "Total Users",
      key: "totalUsersCount",
      icon: faUsers,
      color: "#3699FF",
      count: userCount,
    },
    {
      title: "Resume Completes",
      key: "resumesCount",
      icon: faClipboardCheck,
      color: "#3699FF",
      count: resumeCount,
    },
    {
      title: "Assessments By Job Seekers",
      key: "quizCount",
      icon: faPoll,
      color: "#3699FF",
      count: assessMentCount,
    },
  ];

  const fetchData = async () => {
    if (!user.organization) return;
    let res = await FetchOrganizationDbStats(user.organization);
    setUserCount(res.userCount);
    setResumeCount(res.resumeCount);
    setAssessMentCountCount(res.assessmentCount);
  };

  React.useEffect(() => {
    fetchData();
  }, []);
  return (
    <Box>
      <Grid container spacing={5} justify="space-around" className="main__stats-wrapper">
        {statsList.map((item) => (
          <Grid item xs={12} sm={4} className="main__stats-column">
            <Card className="shadow-sm rounded-lg">
              <Card.Body className=" position-relative px-0 py-0">
                <Grid
                  container
                  style={{ height: "100px" }}
                  direction="row"
                  alignItems="center"
                >
                  <Grid
                    item
                    md={3}
                    style={{
                      backgroundColor: item.color,
                      height: "100%",
                      width: "100%",
                      borderTopLeftRadius: 10,
                      borderBottomLeftRadius: 10,
                    }}
                    container
                    alignItems="center"
                    justify="center"
                    className="stats__box-icon"
                  >
                    <FontAwesomeIcon icon={item.icon} size="3x" color="white" />
                  </Grid>

                  <Grid item md={9} className="stats__box-content">
                    <Typography variant="h6" className="text-center ">
                      {item.title}
                    </Typography>
                    {data ? (
                      <Typography
                        variant="h3"
                        color="primary"
                        className=" py-1 text-center "
                      >
                        {data.getAdminStatistics[item.key] || item.key}
                      </Typography>
                    ) : loading ? (
                      <Box className=" py-1 text-center ">
                        <CircularProgress />
                      </Box>
                    ) : (
                      <Typography
                        variant="h3"
                        className=" py-1 text-center  "
                        color="primary"
                      >
                        {item.count ? item.count : `- -`}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Card.Body>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
